module.exports = __webpack_public_path__ + "static/media/ic_nav_05_selected.41cbf9bf.svg";